import React, { useEffect, useState } from "react";
import defaultLogo from "assets/Logo_New.png";
import rightLogo from "assets/principle_connect_logo.jpg";
import { Link, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "config";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthStatus, signOut } from "reducers/auth";
import { selectBrandLogo } from "reducers/brandSettings";

const SHOW_BUTTONS = false;
const SHOW_HOME_BUTTON = false;
const SHOW_SIGN_IN_BUTTON = false;
const SHOW_REGISTER_BUTTON = false;

type PublicHeaderProps = {
  hideHeader: boolean;
};

const PublicHeader: React.FC<PublicHeaderProps> = ({ hideHeader }) => {
  const navigate = useNavigate();
  const [logo, setLogo] = useState<string | null>(null);

  const brandLogo = useSelector(selectBrandLogo);

  useEffect(() => {
    if (brandLogo) {
      if (brandLogo && brandLogo !== logo) {
        setLogo(brandLogo);
      }
    } else {
      setLogo(defaultLogo);
    }
  }, [brandLogo]);

  const authStatus = useSelector(selectAuthStatus);

  const dispatch = useDispatch();

  const logoRedirect = () => {
    if (
      window &&
      window.location &&
      window.location.pathname &&
      window.location.pathname === APP_ROUTES.signIn &&
      authStatus !== "signed_out"
    ) {
      dispatch(signOut());
    } else if (
      window &&
      window.location &&
      window.location.pathname &&
      window.location.pathname !== APP_ROUTES.signIn &&
      authStatus !== "signed_in"
    ) {
      navigate("/sign-in");
    }
  };

  if (hideHeader) {
    return null;
  }

  return (
    <div className="PublicHeader">
      {logo && (
        <div className="LogoContainer">
          <img className="Logo" src={logo} alt="Logo" onClick={logoRedirect} />
        </div>
      )}

      {SHOW_BUTTONS && (
        <div className="RightContainer">
          <div className="Links">
            {SHOW_HOME_BUTTON && (
              <div className="Link">
                <Link to="/">
                  <span>Home</span>
                </Link>
              </div>
            )}
          </div>

          <div className="Buttons">
            {SHOW_SIGN_IN_BUTTON && (
              <div
                className="Btn"
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                Sign in
              </div>
            )}

            {SHOW_REGISTER_BUTTON && (
              <div
                className="Btn"
                onClick={() => {
                  navigate("/sign-up");
                }}
              >
                Register
              </div>
            )}
          </div>
        </div>
      )}

      {rightLogo && <img className="RightLogo" src={rightLogo} alt="Logo" />}
    </div>
  );
};

export { PublicHeader };
